<template>
    <sticky-header-layout>
      <template #header>
        <div class="action-container">
          <el-pagination
            :disabled="isLoading"
            :current-page="listQuery.page"
            :page-sizes="listQuery.sizes"
            :page-size="listQuery.size"
            :total="listQuery.total"
            background
            layout="total, sizes, pager, jumper"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
          />
          <div class="button-container">
            <el-button
              :disabled="isLoading || isSaving"
              class="add-editorial-item-button"
              size="mini"
              type="primary"
              icon="el-icon-plus"
              @click="handleCreateButtonClick"
            >{{ $t('button.create') }}</el-button>
          </div>
        </div>
      </template>
  
      <!-- Table -->
      <el-table
        v-loading="isLoading"
        :data="list"
        border
        stripe
      >
        <el-table-column
          v-for="column in columnList"
          :key="column.type"
          :prop="column.type"
          :label="$t(`table.${column.type}`)"
          v-bind="column.custom"
        >
          <template #default="{ row }">
            <div>
              {{ row[column.type] }}
            </div>
          </template>
        </el-table-column>
  
        <!-- Actions -->
        <el-table-column
          :label="$t('table.action')"
          fixed="right"
          align="center"
          width="94"
        >
          <template #default="{ row }">
            <div :class="['button-group']">
              <el-button
                size="mini"
                type="warning"
                icon="el-icon-edit"
                circle
                @click="handleEditButtonClick(row)"
              />
            </div>
          </template>
        </el-table-column>
        <!-- Actions -->
      </el-table>
      <!-- Table -->
    </sticky-header-layout>
  </template>
  
  <script>
  import useTablePaging from '../../mixins/useTablePaging'
  import { getBannerSchedules } from '../../api/trendings'
  
  const columnList = [
    {
      type: 'id',
      custom: { width: 50 },
    },
    {
      type: 'date',
      custom: { 'min-width': 60 },
      minWidth: 70,
    },
    {
      type: 'home_carousel_banner_ids',
      custom: { 'min-width': 160 },
    },
    {
      type: 'home_right_banner_ids',
      custom: { 'min-width': 160 },
    },
    {
      type: 'app_promotion_banner_id',
      custom: { 'min-width': 160 },
    },
  ]
  
  export default {
    name: 'FeaturedBrands',
    mixins: [useTablePaging],
    data() {
      return {
        list: [],
        isLoading: false,
        isSaving: false,
        columnList,
      }
    },
    created() {
      this.getList()
    },
    methods: {
      async getList() {
        this.isLoading = true
        try {
          const response = await getBannerSchedules(this.listQuery.page, this.listQuery.size)
          const { data: newList, pagination } = response
          this.list = newList
          this.listQuery.total = parseInt(pagination.total_items, 0)
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false
        }
      },
    //   async deleteBrand(brandId) {
    //     this.isSaving = true
    //     this.deletingId = brandId
    //     try {
    //       const response = await MarketplaceService.deleteFeaturedBrand(brandId)
    //       if (response.code === 200) {
    //         const deletedIndex = this.list.findIndex(({ id }) => id === brandId)
    //         this.list.splice(deletedIndex, 1)
    //       }
    //     } catch (error) {
    //       console.error(error);
    //     } finally {
    //       this.isSaving = false
    //       this.deletingId = null
    //     }
    //   },
      handleCreateButtonClick() {
        this.$router.push({ path: 'banner-schedules/create' })
      },
      handleEditButtonClick(row) {
        this.$router.push({ path: `banner-schedules/edit/${row.id}` })
      },
    //   handleDeleteButtonClick({ id }) {
    //     this.$confirm(this.$t('message.confirmToDelete'), this.$t('common.warning'), {
    //       confirmButtonText: this.$t('button.ok'),
    //       cancelButtonText: this.$t('button.cancel'),
    //       type: 'warning',
    //     }).then(() => {
    //       // Update server
    //       this.deleteBrand(id)
    //     })
    //   },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  @import "@/assets/styles/view-base.scss";
  </style>
  